module.exports = __webpack_public_path__ + "img/387.be3683d7.png";